<div class="card">
    <div class="card-body">
        <div class="mb-4 d-md-flex align-items-center justify-content-between">
            <div>
                <h4>Update Client</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <form [formGroup]="formGroup" (submit)="onSubmit()">
                    <div class="row">
                        <div class="col-md-4 form-group mb-3">
                            <label class="form-label" style="font-weight: 600;     color: #737373;">Client Name</label>
                            <input type="text" [readOnly]="isEditable" class="form-control" formControlName="clientName">
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <label class="form-label"></label>
                            <checkbox single="true" formControlName="sendEmail" class="check-box-top">Send Mail </checkbox>
                        </div>
                        <div class="col-md-4 form-group mb-3">
                            <label class="form-label" style="font-weight: 600;     color: #737373;">Default Country for inquiries</label>
                            <select class="form-control country-select-box" formControlName="defaultCountry">
                                <option value="">Select Country</option>
                                <option value="+93">Afghanistan (+93)</option>
                                <option value="+355">Albania (+355)</option>
                                <option value="+213">Algeria (+213)</option>
                                <option value="+1-684">American Samoa (+1-684)</option>
                                <option value="+376">Andorra (+376)</option>
                                <option value="+244">Angola (+244)</option>
                                <option value="+1-264">Anguilla (+1-264)</option>
                                <option value="+672">Antarctica (+672)</option>
                                <option value="+1-268">Antigua and Barbuda (+1-268)</option>
                                <option value="+54">Argentina (+54)</option>
                                <option value="+374">Armenia (+374)</option>
                                <option value="+297">Aruba (+297)</option>
                                <option value="+61">Australia (+61)</option>
                                <option value="+43">Austria (+43)</option>
                                <option value="+994">Azerbaijan (+994)</option>
                                <option value="+1-242">Bahamas (+1-242)</option>
                                <option value="+973">Bahrain (+973)</option>
                                <option value="+880">Bangladesh (+880)</option>
                                <option value="+1-246">Barbados (+1-246)</option>
                                <option value="+375">Belarus (+375)</option>
                                <option value="+32">Belgium (+32)</option>
                                <option value="+501">Belize (+501)</option>
                                <option value="+229">Benin (+229)</option>
                                <option value="+1-441">Bermuda (+1-441)</option>
                                <option value="+975">Bhutan (+975)</option>
                                <option value="+591">Bolivia (+591)</option>
                                <option value="+387">Bosnia and Herzegovina (+387)</option>
                                <option value="+267">Botswana (+267)</option>
                                <option value="+55">Brazil (+55)</option>
                                <option value="+246">British Indian Ocean Territory (+246)</option>
                                <option value="+1-284">British Virgin Islands (+1-284)</option>
                                <option value="+673">Brunei (+673)</option>
                                <option value="+359">Bulgaria (+359)</option>
                                <option value="+226">Burkina Faso (+226)</option>
                                <option value="+257">Burundi (+257)</option>
                                <option value="+855">Cambodia (+855)</option>
                                <option value="+237">Cameroon (+237)</option>
                                <option value="+1">Canada (+1)</option>
                                <option value="+238">Cape Verde (+238)</option>
                                <option value="+1-345">Cayman Islands (+1-345)</option>
                                <option value="+236">Central African Republic (+236)</option>
                                <option value="+235">Chad (+235)</option>
                                <option value="+56">Chile (+56)</option>
                                <option value="+86">China (+86)</option>
                                <option value="+61">Christmas Island (+61)</option>
                                <option value="+61">Cocos Islands (+61)</option>
                                <option value="+57">Colombia (+57)</option>
                                <option value="+269">Comoros (+269)</option>
                                <option value="+682">Cook Islands (+682)</option>
                                <option value="+506">Costa Rica (+506)</option>
                                <option value="+385">Croatia (+385)</option>
                                <option value="+53">Cuba (+53)</option>
                                <option value="+599">Curacao (+599)</option>
                                <option value="+357">Cyprus (+357)</option>
                                <option value="+420">Czech Republic (+420)</option>
                                <option value="+243">Democratic Republic of the Congo (+243)</option>
                                <option value="+45">Denmark (+45)</option>
                                <option value="+253">Djibouti (+253)</option>
                                <option value="+1-767">Dominica (+1-767)</option>
                                <option value="+1-809">Dominican Republic (+1-809)</option>
                                <option value="+1-829">Dominican Republic (+1-829)</option>
                                <option value="+1-849">Dominican Republic (+1-849)</option>
                                <option value="+670">East Timor (+670)</option>
                                <option value="+593">Ecuador (+593)</option>
                                <option value="+20">Egypt (+20)</option>
                                <option value="+503">El Salvador (+503)</option>
                                <option value="+240">Equatorial Guinea (+240)</option>
                                <option value="+291">Eritrea (+291)</option>
                                <option value="+372">Estonia (+372)</option>
                                <option value="+251">Ethiopia (+251)</option>
                                <option value="+500">Falkland Islands (+500)</option>
                                <option value="+298">Faroe Islands (+298)</option>
                                <option value="+679">Fiji (+679)</option>
                                <option value="+358">Finland (+358)</option>
                                <option value="+33">France (+33)</option>
                                <option value="+689">French Polynesia (+689)</option>
                                <option value="+241">Gabon (+241)</option>
                                <option value="+220">Gambia (+220)</option>
                                <option value="+995">Georgia (+995)</option>
                                <option value="+49">Germany (+49)</option>
                                <option value="+233">Ghana (+233)</option>
                                <option value="+350">Gibraltar (+350)</option>
                                <option value="+30">Greece (+30)</option>
                                <option value="+299">Greenland (+299)</option>
                                <option value="+1-473">Grenada (+1-473)</option>
                                <option value="+1-671">Guam (+1-671)</option>
                                <option value="+502">Guatemala (+502)</option>
                                <option value="+44-1481">Guernsey (+44-1481)</option>
                                <option value="+224">Guinea (+224)</option>
                                <option value="+245">Guinea-Bissau (+245)</option>
                                <option value="+592">Guyana (+592)</option>
                                <option value="+509">Haiti (+509)</option>
                                <option value="+504">Honduras (+504)</option>
                                <option value="+852">Hong Kong (+852)</option>
                                <option value="+36">Hungary (+36)</option>
                                <option value="+354">Iceland (+354)</option>
                                <option value="+91" selected="">India (+91)</option>
                                <option value="+62">Indonesia (+62)</option>
                                <option value="+98">Iran (+98)</option>
                                <option value="+964">Iraq (+964)</option>
                                <option value="+353">Ireland (+353)</option>
                                <option value="+44-1624">Isle of Man (+44-1624)</option>
                                <option value="+972">Israel (+972)</option>
                                <option value="+39">Italy (+39)</option>
                                <option value="+225">Ivory Coast (+225)</option>
                                <option value="+1-876">Jamaica (+1-876)</option>
                                <option value="+81">Japan (+81)</option>
                                <option value="+44-1534">Jersey (+44-1534)</option>
                                <option value="+962">Jordan (+962)</option>
                                <option value="+7">Kazakhstan (+7)</option>
                                <option value="+254">Kenya (+254)</option>
                                <option value="+686">Kiribati (+686)</option>
                                <option value="+383">Kosovo (+383)</option>
                                <option value="+965">Kuwait (+965)</option>
                                <option value="+996">Kyrgyzstan (+996)</option>
                                <option value="+856">Laos (+856)</option>
                                <option value="+371">Latvia (+371)</option>
                                <option value="+961">Lebanon (+961)</option>
                                <option value="+266">Lesotho (+266)</option>
                                <option value="+231">Liberia (+231)</option>
                                <option value="+218">Libya (+218)</option>
                                <option value="+423">Liechtenstein (+423)</option>
                                <option value="+370">Lithuania (+370)</option>
                                <option value="+352">Luxembourg (+352)</option>
                                <option value="+853">Macau (+853)</option>
                                <option value="+389">Macedonia (+389)</option>
                                <option value="+261">Madagascar (+261)</option>
                                <option value="+265">Malawi (+265)</option>
                                <option value="+60">Malaysia (+60)</option>
                                <option value="+960">Maldives (+960)</option>
                                <option value="+223">Mali (+223)</option>
                                <option value="+356">Malta (+356)</option>
                                <option value="+692">Marshall Islands (+692)</option>
                                <option value="+222">Mauritania (+222)</option>
                                <option value="+230">Mauritius (+230)</option>
                                <option value="+262">Mayotte (+262)</option>
                                <option value="+52">Mexico (+52)</option>
                                <option value="+691">Micronesia (+691)</option>
                                <option value="+373">Moldova (+373)</option>
                                <option value="+377">Monaco (+377)</option>
                                <option value="+976">Mongolia (+976)</option>
                                <option value="+382">Montenegro (+382)</option>
                                <option value="+1-664">Montserrat (+1-664)</option>
                                <option value="+212">Morocco (+212)</option>
                                <option value="+258">Mozambique (+258)</option>
                                <option value="+95">Myanmar (+95)</option>
                                <option value="+264">Namibia (+264)</option>
                                <option value="+674">Nauru (+674)</option>
                                <option value="+977">Nepal (+977)</option>
                                <option value="+31">Netherlands (+31)</option>
                                <option value="+599">Netherlands Antilles (+599)</option>
                                <option value="+687">New Caledonia (+687)</option>
                                <option value="+64">New Zealand (+64)</option>
                                <option value="+505">Nicaragua (+505)</option>
                                <option value="+227">Niger (+227)</option>
                                <option value="+234">Nigeria (+234)</option>
                                <option value="+683">Niue (+683)</option>
                                <option value="+850">North Korea (+850)</option>
                                <option value="+1-670">Northern Mariana Islands (+1-670)</option>
                                <option value="+47">Norway (+47)</option>
                                <option value="+968">Oman (+968)</option>
                                <option value="+92">Pakistan (+92)</option>
                                <option value="+680">Palau (+680)</option>
                                <option value="+970">Palestine (+970)</option>
                                <option value="+507">Panama (+507)</option>
                                <option value="+675">Papua New Guinea (+675)</option>
                                <option value="+595">Paraguay (+595)</option>
                                <option value="+51">Peru (+51)</option>
                                <option value="+63">Philippines (+63)</option>
                                <option value="+64">Pitcairn (+64)</option>
                                <option value="+48">Poland (+48)</option>
                                <option value="+351">Portugal (+351)</option>
                                <option value="+1-787">Puerto Rico (+1-787)</option>
                                <option value="+1-939">Puerto Rico (+1-939)</option>
                                <option value="+974">Qatar (+974)</option>
                                <option value="+242">Republic of the Congo (+242)</option>
                                <option value="+262">Reunion (+262)</option>
                                <option value="+40">Romania (+40)</option>
                                <option value="+7">Russia (+7)</option>
                                <option value="+250">Rwanda (+250)</option>
                                <option value="+590">Saint Barthelemy (+590)</option>
                                <option value="+290">Saint Helena (+290)</option>
                                <option value="+1-869">Saint Kitts and Nevis (+1-869)</option>
                                <option value="+1-758">Saint Lucia (+1-758)</option>
                                <option value="+590">Saint Martin (+590)</option>
                                <option value="+508">Saint Pierre and Miquelon (+508)</option>
                                <option value="+1-784">Saint Vincent and the Grenadines (+1-784)</option>
                                <option value="+685">Samoa (+685)</option>
                                <option value="+378">San Marino (+378)</option>
                                <option value="+239">Sao Tome and Principe (+239)</option>
                                <option value="+966">Saudi Arabia (+966)</option>
                                <option value="+221">Senegal (+221)</option>
                                <option value="+381">Serbia (+381)</option>
                                <option value="+248">Seychelles (+248)</option>
                                <option value="+232">Sierra Leone (+232)</option>
                                <option value="+65">Singapore (+65)</option>
                                <option value="+1-721">Sint Maarten (+1-721)</option>
                                <option value="+421">Slovakia (+421)</option>
                                <option value="+386">Slovenia (+386)</option>
                                <option value="+677">Solomon Islands (+677)</option>
                                <option value="+252">Somalia (+252)</option>
                                <option value="+27">South Africa (+27)</option>
                                <option value="+82">South Korea (+82)</option>
                                <option value="+211">South Sudan (+211)</option>
                                <option value="+34">Spain (+34)</option>
                                <option value="+94">Sri Lanka (+94)</option>
                                <option value="+249">Sudan (+249)</option>
                                <option value="+597">Suriname (+597)</option>
                                <option value="+47">Svalbard and Jan Mayen (+47)</option>
                                <option value="+268">Swaziland (+268)</option>
                                <option value="+46">Sweden (+46)</option>
                                <option value="+41">Switzerland (+41)</option>
                                <option value="+963">Syria (+963)</option>
                                <option value="+886">Taiwan (+886)</option>
                                <option value="+992">Tajikistan (+992)</option>
                                <option value="+255">Tanzania (+255)</option>
                                <option value="+66">Thailand (+66)</option>
                                <option value="+228">Togo (+228)</option>
                                <option value="+690">Tokelau (+690)</option>
                                <option value="+676">Tonga (+676)</option>
                                <option value="+1-868">Trinidad and Tobago (+1-868)</option>
                                <option value="+216">Tunisia (+216)</option>
                                <option value="+90">Turkey (+90)</option>
                                <option value="+993">Turkmenistan (+993)</option>
                                <option value="+1-649">Turks and Caicos Islands (+1-649)</option>
                                <option value="+688">Tuvalu (+688)</option>
                                <option value="+1-340">U.S. Virgin Islands (+1-340)</option>
                                <option value="+256">Uganda (+256)</option>
                                <option value="+380">Ukraine (+380)</option>
                                <option value="+971">United Arab Emirates (+971)</option>
                                <option value="+44">United Kingdom (+44)</option>
                                <option value="+1">United States (+1)</option>
                                <option value="+598">Uruguay (+598)</option>
                                <option value="+998">Uzbekistan (+998)</option>
                                <option value="+678">Vanuatu (+678)</option>
                                <option value="+379">Vatican (+379)</option>
                                <option value="+58">Venezuela (+58)</option>
                                <option value="+84">Vietnam (+84)</option>
                                <option value="+681">Wallis and Futuna (+681)</option>
                                <option value="+212">Western Sahara (+212)</option>
                                <option value="+967">Yemen (+967)</option>
                                <option value="+260">Zambia (+260)</option>
                                <option value="+263">Zimbabwe (+263)</option>
                            </select>
                        </div>
                        <div *ngIf="sendEmailIsEnabled()" class="col-md-4 form-group mb-3">
                            <label class="form-label">Clien Logo</label>
                            <input type="text" class="form-control" formControlName="mailLogo">
                        </div>
                        <div *ngIf="sendEmailIsEnabled()" class="col-md-4 form-group mb-3">
                            <label class="form-label">Client Name</label>
                            <input type="text" class="form-control" formControlName="mailName">
                        </div>
                        <div *ngIf="sendEmailIsEnabled()" class="col-md-4 form-group mb-3">
                            <label class="form-label">Email for send Inquiries</label>
                            <input type="text" class="form-control" formControlName="mailEmail">
                        </div>
                        <div *ngIf="sendEmailIsEnabled()" class="col-md-4 form-group mb-3">
                            <label class="form-label">SMTP Host Name</label>
                            <input type="text" class="form-control" formControlName="smtpHostName">
                        </div>
                        <div *ngIf="sendEmailIsEnabled()" class="col-md-4 form-group mb-3">
                            <label class="form-label">SMTP User Name</label>
                            <input type="email" class="form-control" formControlName="smtpUserName">
                        </div>
                         <div *ngIf="sendEmailIsEnabled()" class="col-md-4 form-group mb-3">
                            <label class="form-label">SMTP Password</label>
                            <input type="text" class="form-control" formControlName="smtpUserPassword">
                        </div>
                         <div *ngIf="sendEmailIsEnabled()" class="col-md-4 form-group mb-3">
                            <label class="form-label">SMTP Port</label>
                            <input type="text" class="form-control" formControlName="smtpUserPort">
                        </div>
                        <div *ngIf="sendEmailIsEnabled()" class="col-md-4 form-group mb-3">
                            <label class="form-label"></label>
                            <checkbox single="true" formControlName="captchaEnabled">Google Captcha Enable </checkbox>
                        </div>
                        <div *ngIf="sendCaptchaIsEnabled()" class="col-md-4 form-group mb-3">
                            <label class="form-label">Google Captcha Secret Key</label>
                            <input type="text" class="form-control" formControlName="captchaKey">
                        </div>
                        <div class="col-md-12 mb-3">
                        <div class="table-responsive">
                            <table class="table table-striped InputTable update-client-table">
                                <thead>
                                    <tr>
                                        <th>
                                            <button type="button" class="btn btn-icon btn-rounded btn-primary" (click)="addRow()">
                                               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-plus h-4 w-4"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>
                                            </button>
                                        </th>
                                        <th style="min-width: 110px;font-weight: 600;     color: #737373;">Form Name</th>
                                        <th style="min-width: 110px;font-weight: 600;     color: #737373;">Email Field Exist</th>
                                        <th *ngIf="sendEmailIsEnabled()" style="min-width: 110px;font-weight: 600;     color: #737373;">Emails for send inquires</th>
                                        <th *ngIf="sendEmailIsEnabled()" style="min-width: 110px;font-weight: 600;     color: #737373;">Success Mail Message</th>
                                        <th *ngIf="sendEmailIsEnabled()" style="min-width: 110px;font-weight: 600;     color: #737373;">Onscreen Success Message</th>
                                    </tr>
                                </thead>
                                <tbody formArrayName="clientForms">
                                    <tr *ngFor="let product of formGroup.get('clientForms')['controls']; let i = index" [formGroupName]="i">
                                        <td scope="row">
                                            <button type="button" class="btn btn-icon btn-rounded btn-danger" (click)="removeRow(i)">
                                               <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trash2"><path d="M3 6h18"></path><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"></path><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"></path><line x1="10" x2="10" y1="11" y2="17"></line><line x1="14" x2="14" y1="11" y2="17"></line></svg>
                                            </button>
                                        </td>
                                        <td>
                                            <input type="text" #firstInput class="form-control" placeholder="Form Name" formControlName="FormName"/>
                                        </td>
                                        <td>
                                            <checkbox single="true" formControlName="isEmailExist"></checkbox>
                                        </td>
                                        <td *ngIf="sendEmailIsEnabled()">
                                            <textarea class="form-control" placeholder="Email Ids" formControlName="emailIds"></textarea>
                                        </td>
                                        <td *ngIf="sendEmailIsEnabled()">
                                            <textarea #secondInput class="form-control" placeholder="Mail Message" formControlName="successMailMsg"></textarea>
                                        </td>
                                        <td *ngIf="sendEmailIsEnabled()">
                                            <textarea class="form-control" placeholder="On Screen Message" formControlName="onScreenMsg"></textarea>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                      </div>
                    </div>
                    <div class="text-end">
                        <button class="btn btn-primary ml-2" type="submit">Update Client</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>